import { appContext } from "../../../AppContext";
import { IbssComponent } from "../../Core/BaseComponent/IbssComponent";
import { JSX } from "react";
import "./Styles.scss";
import { ThemeId } from "../../../Common/CustomTheme";
import { SerendieSymbol } from "@serendie/symbols";
import { Button, ButtonBar, Card, Dialog, DialogContent, DialogFooter, DropDownMenu, GridContainer, GridItem, RightButtons } from "@iconics/components";

export class ThemeDialog extends IbssComponent<IProps, IState>
{
    private labels = appContext().labels;
    
    constructor(props: IProps)
    {
        super(props);
        this.state = {
            selectedThemeId: appContext().state.themeId,
            originalThemeId: appContext().state.themeId,
        };
    }

    private themes = [
        {
            id: 'konjo',
            icon: <SerendieSymbol name='circle' variant='filled' color='#0650A0' />,
            text: this.labels.Platform_ThemeMenu_Konjo,
        },
        {
            id: 'asagi',
            icon: <SerendieSymbol name='circle' variant='filled' color='#00757d' />,
            text: this.labels.Platform_ThemeMenu_Asagi,
        },
        {
            id: 'kurikawa',
            icon: <SerendieSymbol name='circle' variant='filled' color='#813410' />,
            text: this.labels.Platform_ThemeMenu_Kurikawa,
        },
        {
            id: 'sumire',
            icon: <SerendieSymbol name='circle' variant='filled' color='#733b85' />,
            text: this.labels.Platform_ThemeMenu_Sumire,
        },
        {
            id: 'tsutsuji',
            icon: <SerendieSymbol name='circle' variant='filled' color='#f5c0d0' />,
            text: this.labels.Platform_ThemeMenu_Tsutsji,
        },
    ];

    public async componentDidMount(): Promise<void>
    {
        appContext().state.autoMap(this, i => ({ selectedThemeId: i.themeId }));
    }

    private handleThemeChange(value: ThemeId): void
    {
        appContext().state.set({ themeId: value });
    }

    private handleCancel(): void
    {
        appContext().state.set({ themeId: this.state.originalThemeId });
        this.props.onClose()
    }

    public render(): JSX.Element
    {
        const { labels } = appContext();

        return (
            <Dialog
                isOpen={this.props.open}
                onOpenChange={() => this.handleCancel()}
                lg={4}
            >
                <DialogContent>
                    <Card
                        title={labels.Platform_ThemeMenu_Title}
                        subTitle={labels.Platform_ThemeMenu_SubTitle}
                    >
                        <GridContainer>
                            <GridItem>
                                <DropDownMenu
                                    label={labels.Platform_ThemeMenu_Theme}
                                    placeholder={this.themes.find(i => i.id === this.state.selectedThemeId)?.text ?? this.themes[0].text}
                                    onSelect={e => this.handleThemeChange(e.value as unknown as ThemeId)}
                                    items={this.themes.map(i => ({ value: i.id, label: i.text, icon: i.icon }))}
                                />
                            </GridItem>
                        </GridContainer>
                    </Card>
                </DialogContent>
                <DialogFooter>
                    <ButtonBar>
                        <RightButtons>
                            <Button
                                styleType='outlined'
                                onClick={() => this.handleCancel()}
                            >
                                {labels.Platform_CommonAction_Cancel}
                            </Button>
                            <Button
                                styleType='filled'
                                onClick={() => this.props.onClose()}
                            >
                                {labels.Platform_CommonAction_Save}
                            </Button>
                        </RightButtons>
                    </ButtonBar>
                </DialogFooter>

            </Dialog>
        );
    }
}

export interface IProps
{
    open: boolean;
    onClose: () => void;
}

export interface IState
{
    selectedThemeId: ThemeId;
    originalThemeId: ThemeId;
}

export interface ITheme
{
    id: ThemeId;
    icon: JSX.Element;
    text: string;
}
